













import Vue from 'vue'
import RunDetail from '@/components/spiders/results/run-detail.vue'

export default Vue.extend({
  components: {
    RunDetail,
  },
})
